import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class MnoMappingService {

  constructor(private httpClient: HttpClient,  @Inject('apiEndPoint') private apiEndPoint: string,) { }

  deviceStatsticks() {
    const requestOptions = {
      headers: { "Content-Type": "application/json" }
    }
  }
  getAllMnos(selectedTemplate: any, selectedRegion: any, selectedMnos: any ) {
    var queryarray = []
    if (selectedTemplate) {
      queryarray.push(
          { "wildcard": { "template_name": { "value": '*' + selectedTemplate + '*', "case_insensitive": true } } }
      )
  } if (selectedRegion) {
      queryarray.push({
          query_string: {
              query: selectedRegion,
              type: "phrase",
              fields: ["region"],
          }
      })
  }
  if (selectedMnos) {
      queryarray.push({
          query_string: {
              query: selectedMnos,
              type: "phrase",
              fields: ["mno"],
          }
      })
  }
    const params = { "query": { "bool": { "must": queryarray } }, "sort": [{ "_kuzzle_info.createdAt": "desc" }] }
    return this.httpClient.post( this.apiEndPoint + '/gwdevice/band_template/_search?size=1000', params)
  }
  getMnoBandDetails(){
    return this.httpClient.get(this.apiEndPoint + '/gwdevice/band_details/_search?size=1000');

  }
  getRegions() {
    return this.httpClient.get('assets/jsons/countries.json')
  }
  getGroupsCount(queryParams){
    return this.httpClient.post(this.apiEndPoint + '/gwdevice/devicegroup/_search?size=1000', queryParams);
  }
  getDelectRowData(queryParams){
    return this.httpClient.post(this.apiEndPoint + '/gwdevice/band_template/w52eg4YBMu1YOR72Hoaj', queryParams);
  }
  createMno(obj){
    return this.httpClient.post(this.apiEndPoint + '/gwdevice/band_template/_create', obj);
  }
  createNewMno(obj){
    return this.httpClient.post(this.apiEndPoint + '/gwdevice/band_details/_create', obj);
  }
  updateMno(obj: any, id: any){
    return this.httpClient.put(this.apiEndPoint + `/gwdevice/band_template/${id}/_update`, obj);
  }
  deleteMno( id: any){
    return this.httpClient.delete(this.apiEndPoint + `/gwdevice/band_template/${id}`);
  }
  updateMnoExisting(obj: any, id: any){
    return this.httpClient.put(this.apiEndPoint + `/gwdevice/band_details/${id}/_update`, obj);
  }
  deleteMnoExisting( id: any){
    return this.httpClient.delete(this.apiEndPoint + `/gwdevice/band_details/${id}`);
  }
}

export const getImeiNumbersWithBandFilter = async (bands) => {
  var queryarray = []
  if (bands.bands_4g && bands.bands_4g.length > 0) {
    var band_4g = bands.bands_4g.map((item) => "(" + item + ")");
    band_4g = band_4g.join(" AND ")
    queryarray.push({
      query_string: {
        query: band_4g,
        type: "phrase",
        fields: ["band_info.SUPPORTED_BAND_4G"],
      },

    },)
  }
  if (bands.bands_5g && bands.bands_5g.length > 0) {
    var band_5g = bands.bands_5g.map((item) => "(" + item + ")");
    band_5g = band_5g.join(" AND ")
    queryarray.push({
      query_string: {
        query: band_5g,
        type: "phrase",
        fields: ["band_info.SUPPORTED_BAND_5G"],
      },

    })
  }
  if (bands.bands_nsa_5g && bands.bands_nsa_5g.length > 0) {
    var band_NSA_5g = bands.bands_nsa_5g.map((item) => "(" + item + ")");
    band_NSA_5g = band_NSA_5g.join(" AND ")
    queryarray.push({
      query_string: {
        query: band_NSA_5g,
        type: "phrase",
        fields: ["band_info.SUPPORTED_BAND_NSA_5G"],
      }
    })
  }
  console.log(band_4g)
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      query: {
        bool: {
          must: queryarray,
        },
      },
      sort: [{ "_kuzzle_info.createdAt": "desc" }],
    }),
  };
  return new Promise((resolve) => {
    fetch( "https://staging.viaviedge.net:8007/gwdevice/band_template/_search?size=1000", requestOptions)
      .then((response) => response.json())
      .then((data) => {
        let hits = data?.result?.hits;
        let imeiNumbers = [];
        hits.forEach((item) => {
          let data = imeiNumbers.find(
            (x) => item?._source?.imei == x?._source?.imei
          );
          if (!data) {
            imeiNumbers.push(item);
          }
        });

        resolve(imeiNumbers);
      })
      .catch((error) => resolve([]));
  });
};
